/**
 * Format a byte count as a human-readable string with binary (1024-step) units.
 *
 * - `0` returns `"0 B"`.
 * - Smaller-than-1KB values stay in bytes (no fractional bytes).
 * - Larger values pick the largest unit whose value is >= 1 and render with
 *   two decimals, e.g. `1.50 KB`, `3.00 MB`, `1.07 GB`.
 *
 * Extracted from inline copies in `InstallersPage.tsx`, `TrainingFilesTab.tsx`,
 * and `TrainingFileUploadDialog.tsx`. Single source of truth so future UI
 * widgets can rely on consistent formatting.
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}
